import type { FC, HTMLAttributes, ReactNode } from 'react';

type TextProps = {
  children: ReactNode;
} & Pick<
  HTMLAttributes<HTMLElement>,
  'className' | 'id' | 'aria-label' | 'aria-labelledby' | 'aria-hidden'
>;

const withText =
  (TextComponent: FC<TextProps>): FC<TextProps> =>
  ({ children, ...props }: TextProps) => {
    if (!children) {
      return null;
    }

    return <TextComponent {...props}>{children}</TextComponent>;
  };

export { withText };
export type { TextProps };
